import { AssociatesState, AssociatesActionTypes, READ_ASSOCIATES_DATA_REQUEST, READ_ASSOCIATES_DATA_SUCCESS, READ_ASSOCIATES_DATA_FAILURE } from "store/reducers/types/associates/associates";

const defaultState: AssociatesState = {
  isLoading: false,
  errorMessage: ""
};

export default function associates(state = defaultState, action: AssociatesActionTypes): AssociatesState {
  switch (action.type) {
    case READ_ASSOCIATES_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_ASSOCIATES_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_ASSOCIATES_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};